// Modal wyboru akcji dla nowej kalkulacji (krok 1 flowu "Dodaj kalkulacje").
// 3 opcje: stwórz nową, utwórz na podstawie istniejącej, powiąż (współdzielenie).

import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

import { WiseModal } from 'components/wise';

import styles from 'theme/components/containers/TraderClientOfferProductsContainer/ChooseCalculationActionModal.module.scss';

interface IChooseCalculationActionModalProps {
  open: boolean;
  onClose: () => void;
  onCreateNew: () => void;
  onCreateFromExisting: () => void;
  onLink: () => void;
  productName: string;
}

const ChooseCalculationActionModal: FC<IChooseCalculationActionModalProps> = ({
  open,
  onClose,
  onCreateNew,
  onCreateFromExisting,
  onLink,
  productName
}) => {
  const { t } = useTranslation();

  return (
    <WiseModal
      open={open}
      onClose={onClose}
      title={t('salesCrm.calculation.chooseAction.title')}
      maxWidth={560}>
      <div className={styles.body}>
        {productName && (
          <div className={styles.intro}>
            {t('salesCrm.calculation.addPosition.product')}: <strong>{productName}</strong>
          </div>
        )}

        <button type="button" className={styles.option} onClick={onCreateNew}>
          <span className={styles.optionLabel}>
            {t('salesCrm.calculation.chooseAction.createNew')}
          </span>
        </button>

        <button type="button" className={styles.option} onClick={onCreateFromExisting}>
          <span className={styles.optionLabel}>
            {t('salesCrm.calculation.chooseAction.createFromExisting')}
          </span>
        </button>

        <button type="button" className={styles.option} onClick={onLink}>
          <span className={styles.optionLabel}>
            {t('salesCrm.calculation.chooseAction.link')}
          </span>
        </button>

        <div className={styles.actions}>
          <Button onClick={onClose} variant="text">
            {t('common.cancel')}
          </Button>
        </div>
      </div>
    </WiseModal>
  );
};

export default ChooseCalculationActionModal;
